// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4cb2c56b","732":"09147303","977":"2d8ecdf3"}[chunkId] + ".chunk.js";
};